import { type FC } from 'react';
import downIcon from '@assets/images/header/down.svg';

import styles from './more.module.scss';

interface OwnProps {
  show: boolean;
  toggleShow(value?: boolean): void;
}

const More: FC<OwnProps> = ({ show, toggleShow }) => {
  return (
    <div className={styles.more} onClick={() => toggleShow()}>
      <div>{show ? 'Less' : 'More'} Parameters</div>
      <img src={downIcon} className={show ? styles.active : ''} />
    </div>
  );
};

export default More;
